import { z } from "zod";

const canPostalCodePattern = /^[a-zA-Z]\d[a-zA-Z] ?\d[a-zA-Z]\d$/;

function normalizeCanPostalCode(rawValue: string): string {
  const stripped = rawValue.replace(/\s/g, "").toUpperCase();
  return stripped.length === 6
    ? `${stripped.slice(0, 3)} ${stripped.slice(3)}`
    : rawValue;
}

function isValidCanPostalCode(value: string): boolean {
  return canPostalCodePattern.test(value);
}

const canPostalCode = z.string().regex(canPostalCodePattern);

export {
  canPostalCode,
  canPostalCodePattern,
  isValidCanPostalCode,
  normalizeCanPostalCode,
};
